document.addEventListener('DOMContentLoaded', () => {
    const header = document.getElementById('js-header');
    const hamburger = document.getElementById('js-hamburger');
    const drawer = document.getElementById('js-drawer-menu');
    const overlay = document.getElementById('js-drawer-overlay');
    const navLinks = document.querySelectorAll('.p-drawer__link');
  
    // スクロールバーの幅を取得する関数
    // const getScrollbarWidth = () => {
    //   return window.innerWidth - document.documentElement.clientWidth;
    // };
  
    // メニュー開閉時のトグル処理
    const toggleMenu = () => {
      const isOpen = header.classList.toggle('is-active');
  
      // aria属性の更新
      hamburger.setAttribute('aria-expanded', isOpen);
      drawer.setAttribute('aria-hidden', !isOpen);
      hamburger.setAttribute('aria-label', isOpen ? 'メニューを閉じる' : 'メニューを開く');
  
    //   if (isOpen) {

    //     const scrollbarWidth = getScrollbarWidth();
    //     document.body.style.paddingRight = `${scrollbarWidth}px`;
        
    //     if (header) {
    //       header.style.paddingRight = `${scrollbarWidth}px`;
    //     }

    //     document.body.style.overflow = 'hidden';
    //   } else {

    //     document.body.style.overflow = '';
    //     document.body.style.paddingRight = '';
    //     if (header) {
    //       header.style.paddingRight = '';
    //     }
    //   }
    };
  
    // イベント設定
    hamburger.addEventListener('click', toggleMenu);
  
    if (overlay) {
      overlay.addEventListener('click', toggleMenu);
    }
  
    navLinks.forEach(link => {
      link.addEventListener('click', () => {
        if (header.classList.contains('is-active')) {
          toggleMenu();
        }
      });
    });
  });